import React from "react";
import { useHistory, useLocation, useRouteMatch } from "react-router";

import { URL } from "../../constants/navigation";
import { Button } from "../../UI/Button";

interface IProps {
  name: string;
  id: string;
  openNewTab?: boolean;
}

export const UserNameLink: React.FC<IProps> = (props) => {
  const { push } = useHistory();
  const location = useLocation();

  const usersMatch = useRouteMatch(URL.USER);
  const usersInviteMatch = useRouteMatch(URL.USERS_INVITE);
  const usersRemoveMatch = useRouteMatch(URL.USERS_REMOVE);
  const usersSearchMatch = useRouteMatch(URL.USERS_SEARCH);
  const usersMatchMatch = useRouteMatch(URL.USERS_MATCH);

  const userReportMatch = useRouteMatch(URL.USER_REPORT);
  const roommateMatchingReportMatch = useRouteMatch(URL.ROOMMATE_MATCHING_REPORT);

  const breadcrumbs = React.useMemo(
    () =>
      [
        !!usersInviteMatch && URL.USERS_INVITE,
        !!usersRemoveMatch && URL.USERS_REMOVE,
        !!usersSearchMatch && `${URL.USERS_SEARCH}${location.search || ""}`,
        !!usersMatchMatch && URL.USERS_MATCH,
        !!usersMatch && `${URL.USERS_SEARCH}${location.search || ""}`,
        !!userReportMatch && URL.USER_REPORT,
        !!roommateMatchingReportMatch && URL.ROOMMATE_MATCHING_REPORT,
      ].filter(Boolean),
    [
      location.search,
      usersInviteMatch?.isExact,
      usersRemoveMatch?.isExact,
      usersSearchMatch?.isExact,
      usersMatchMatch?.isExact,
      usersMatch?.isExact,
      userReportMatch?.isExact,
      roommateMatchingReportMatch?.isExact,
    ]
  );

  const handleClick = () => {
    if (props.openNewTab) {
      window.open(URL.USER.replace(":id", props.id), "_blank");
    } else {
      push(URL.USER.replace(":id", props.id), {
        breadcrumbs,
      });
    }
  };

  return (
    <Button appearance="link" spacing="none" onClick={handleClick}>
      {props.name}
    </Button>
  );
};

UserNameLink.defaultProps = {
  openNewTab: false,
};
